'use client'

import { useRouter } from 'next/navigation'
import { useEffect, useState } from 'react'
import { getMemoryListByNpcId } from '@/lib/api/home'
import { navigatePush } from '@/lib/utils/navigation'
import type { MemoryItem } from '@/types'
import type { CharacterChatViewData } from '@/types/characterChat'

export interface CharacterMemoriesPreview {
  records: MemoryItem[]
  total: number
}

/** 角色 Memories 入口卡数据：拉取该角色前 3 条记忆 + 总数，并提供跳转。 */
export function useCharacterMemories(character: CharacterChatViewData) {
  const router = useRouter()
  const [preview, setPreview] = useState<CharacterMemoriesPreview>({ records: [], total: 0 })

  useEffect(() => {
    if (!character.id) return
    let cancelled = false

    void getMemoryListByNpcId({
      npcId: character.id,
      params: { page: 1, size: 3 },
    })
      .then((response) => {
        if (cancelled) return
        if (response.code === 200 && response.data) {
          setPreview({
            records: response.data.records || [],
            total: response.data.total || 0,
          })
        }
      })
      .catch(() => {})

    return () => {
      cancelled = true
    }
  }, [character.id])

  const openPlaza = () => {
    navigatePush(router, `/memory?npcId=${encodeURIComponent(character.id)}`)
  }

  const openDetail = (item: MemoryItem) => {
    navigatePush(router, `/memory/${item.id}`)
  }

  return { preview, openPlaza, openDetail }
}
